<template>
    <div>
        <space-avatar class="is-96x96 avatar" :space="space"/><br/>

        <label>
            <base-button
                :loading="update.loading"
                class="is-primary"
                icon="fas fa-upload"
                text="Upload new avatar"/>

            <input type="file" class="is-hidden" @change="send"/>
        </label>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { copy } from '../../utils/helpers';
import SpaceAvatar from './SpaceAvatar.vue';

export default {
    name: 'SpaceSettingsAvatar',
    components: { SpaceAvatar },
    props: ['space'],
    computed: mapState('spaces', ['update']),
    data() {
        return { form: copy(this.space) };
    },
    methods: {
        send(event) {
            const data = new FormData();
            data.append('photo', event.target.files[0]);
            this.$store.dispatch('spaces/update', { space_id: this.space.id, data });
        },
    },
};
</script>

<style scoped>
    .avatar {
        margin-left: 1.7rem;
    }
</style>
